var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.headerTitle,"button":_vm.headerButton}}),_c('div',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"All Products","active":""}},[_c('products-table')],1),_c('b-tab',{attrs:{"title":"Publish"}}),_c('b-tab',{attrs:{"title":"Published"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }